export const environment = {
  production: true,
  appVersion: require('../../package.json').version + '-dev',
  appName: require('../../package.json').name,
  appPrefix: 'notifmgr',

  lang: 'de',
  notifmgrBackendUrl: 'https://essp-api-benotifmgr-dev.acp-gruppe.com',
  portalMetaBackendUrl: 'https://essp-api-beportalmetadata-dev.acp-gruppe.com',
  portalHomeUrl: 'https://essp-dev.acp-gruppe.com',
  stage: 'dev',
  issuer: 'https://ciam-dev.acp-gruppe.com',
  tokenEndpoint: 'https://ciam-dev.acp-gruppe.com/token-srv/token',
  clientId: 'c0a82a0e-9db4-4890-b94d-6af4a75a4381',
  scope: 'openid profile roles groups acpprofile offline_access',
};
